import { useState } from 'react';
import { FaLink } from 'react-icons/fa'
import Button from 'react-bootstrap/Button'

const CopyLinkButton = ({ text, url }) => {
  // State to show feedback after copying
  const [copyStatus, setCopyStatus] = useState('');

  // Function to handle copy to clipboard
  const handleCopyClick = async () => {
    try {
      // Check if navigator.clipboard is supported
      if (!navigator.clipboard) {
        throw new Error('Clipboard API not supported');
      }
      // Copy the referral URL to clipboard
      await navigator.clipboard.writeText(url);
      // Show success message
      setCopyStatus('Copied!');
      // Reset status after 2 seconds
      setTimeout(() => setCopyStatus(''), 2000);
    } catch (error) {
      // Handle errors (e.g., browser doesn't support clipboard API or permission denied)
      setCopyStatus('Failed to copy');
      console.error('Copy failed:', error);
      setTimeout(() => setCopyStatus(''), 2000);
    }
  };

  return (
    <div>
      <Button
        onClick={handleCopyClick}
        variant="outline"
        className="btn-outline-secondary"
      >
        <FaLink /> {text}
      </Button>
      {copyStatus && (
        <span style={{ marginLeft: '10px', color: copyStatus.includes('Failed') ? 'red' : 'green' }}>
          {copyStatus}
        </span>
      )}
    </div>
  );
};

export default CopyLinkButton;